import styled from 'styled-components';
export const ButtonChildrenStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: ${({ endAdornment }) => (endAdornment ? 'left' : 'center')};
  column-gap: 10px;
  width: 100%;
`;
export const ButtonStyled = styled.button `
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);
  position: relative;
  border-radius: 10px;
  border: 0px;
  text-align: center;
  display: ${(props) => (props.loading ? 'flex' : 'inline-flex')};
  align-items: center;
  column-gap: 10px;
  justify-content: 'center';
  cursor: pointer;

  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};

  padding: ${(props) => {
    switch (props.size) {
        case 'small':
            return `8px 22px`;
        case 'large':
            return `18px 32px`;
        default:
            return `12px 26px`;
    }
}};

  height: ${(props) => {
    switch (props.size) {
        case 'small':
            return `32px`;
        case 'large':
            return `52px`;
        default:
            return `40px`;
    }
}};

  ${(props) => {
    return props.size === 'large' ? props.theme.typography.button1 : props.theme.typography.button2;
}}

  line-height: ${(props) => {
    switch (props.size) {
        case 'small':
            return `32px`;
        case 'large':
            return `52px`;
        default:
            return `40px`;
    }
}};

  ${({ variant, theme: { colors }, disabled, loading }) => {
    if (disabled && !loading)
        return '';
    switch (variant) {
        case 'ghost':
            return `
          box-shadow: none;
          background: linear-gradient(270deg, ${colors.blue500} 0%, ${colors.blue500} 39.9%, ${colors.lightBlue500} 100%);
          -webkit-background-clip: text, padding-box;
          background-clip: text, padding-box;
          -webkit-text-fill-color: transparent;
        `;
        case 'inverted':
            return `
          color: ${colors.gray100};
          background: linear-gradient(227deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(270deg, #50CAFF 0%, #0478FF 100%);
          ${!loading &&
                `:active {
            box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
            background: linear-gradient(270deg, ${colors.blue500} 0%, ${colors.blue500} 39.9%, ${colors.lightBlue500} 100%), ${colors.gray100};
            -webkit-background-clip: text, padding-box;
            background-clip: text, padding-box;
            -webkit-text-fill-color: transparent;
            
            @-moz-document url-prefix() {
              -webkit-text-fill-color: unset;
              background-clip: unset;
              background: #FFF;
              background-color: #FFF;
              color: ${colors.blue500};
            }
          }`}
        `;
        default:
            return `
          color: ${colors.gray700};
          background-color: #e3edf7;
            ${!loading &&
                `:active {
                box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
                background: linear-gradient(270deg, ${colors.blue500} 0%, ${colors.blue500} 39.9%, ${colors.lightBlue500} 100%), ${colors.gray100};
                -webkit-background-clip: text, padding-box;
                background-clip: text, padding-box;
                -webkit-text-fill-color: transparent;
                @-moz-document url-prefix() {
                  -webkit-text-fill-color: unset;
                  background-clip: unset;
                  background: #FFF;
                  background-color: #FFF;
                  color: ${colors.blue500};
                }
              }`}
          
        `;
    }
}}

  :disabled {
    ${({ theme: { colors }, loading }) => {
    if (loading)
        return '';
    return `
        background-color: ${colors.gray200};
        color: ${colors.gray500};
        `;
}}
  }

  ::before {
    position: absolute;
    content: '';
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 11px;
    z-index: -1;
    ${({ variant, disabled }) => {
    if (disabled)
        return `
          background: linear-gradient(0deg,#E0E3E9, #FFF);
        `;
    switch (variant) {
        case 'ghost':
            return `
            background: transparent;
          `;
        case 'inverted':
            return `
            background: linear-gradient(90deg, rgb(214, 227, 243, 0.90) 0%, #FFF 60%);
            ${!disabled &&
                `:active {
              background:#FFFFFF;
            }`}
          `;
        default:
            return `
            background: linear-gradient(0deg, #e7eff8, #FFFFFF);
              ${!disabled &&
                `:active {
              background:#FFFFFF;
            }`}
          `;
    }
}}
  }
`;
//# sourceMappingURL=styled.js.map